// Ekran 14 — Ayarlar API istemcisi.

import { api } from '../../lib/api'
import type { KullaniciDurumu, Rol } from '../account/api'

export type TesisAyarlari = {
  sirket: string
  tesisKod: string
  tesisAd: string
  kuruluGuc: number | null
  lisansNo: string | null
  cr1Hacim: number | null
  cr2Hacim: number | null
  sc1Hacim: number | null
  etaEl: number | null
  saatDilimi: string
  paraBirimi: string
  sifreOmruGun: number
  /** Motorun V_hedef'i — SC-1 dahil DEĞİL (K10). */
  vHedef: Record<string, number>
}

export type TesisAyarlariIstek = {
  tesisAd: string
  kuruluGuc: number | null
  lisansNo: string | null
  cr1Hacim: number | null
  cr2Hacim: number | null
  sc1Hacim: number | null
  etaEl: number | null
  saatDilimi: string | null
  paraBirimi: string | null
  sifreOmruGun: number | null
}

export type EsikKalibi =
  | 'ustSinir'
  | 'aralikUstteKirmizi'
  | 'aralikAlttaKirmizi'
  | 'aralik'
  | 'tolerans'

export type EsikSatiri = {
  gosterge: string
  etiket: string
  birim: string | null
  normalMin: number | null
  normalMax: number | null
  amber: number | null
  kirmizi: number | null
  kalip: EsikKalibi
  nasilOkunur: string
  kullanildigiYer: string
  /** Kalıba göre düzenlenebilir kolonlar; diğerleri kapalı gösterilir. */
  kolonlar: string[]
}

export type EsikYaz = {
  gosterge: string
  normalMin: number | null
  normalMax: number | null
  amber: number | null
  kirmizi: number | null
}

export type KullaniciSatiri = {
  id: string
  eposta: string
  ad: string
  unvan: string | null
  tel: string | null
  rol: Rol
  rolAdi: string
  durum: KullaniciDurumu
  yetkiOnay: boolean
  yetkiStorno: boolean
  sonGiris: string | null
  sifreDegisimZamani: string | null
  tesisler: string[]
  kendisi: boolean
}

export type KullaniciDavet = {
  eposta: string
  ad: string
  unvan: string | null
  tel: string | null
  rol: Rol
  yetkiOnay: boolean
  yetkiStorno: boolean
  tesisIdler: string[]
  baslangicSifresi: string
}

export type KullaniciGuncelle = {
  ad: string
  unvan: string | null
  tel: string | null
  rol: Rol
  durum: KullaniciDurumu
  yetkiOnay: boolean
  yetkiStorno: boolean
  tesisIdler: string[]
}

export type RolMatrisi = {
  roller: { anahtar: Rol; ad: string; kisaAd: string; kullaniciSayisi: number }[]
  moduller: { anahtar: string; ad: string }[]
  /** modül → rol → "yok" | "oku" | "yaz" */
  matris: Record<string, Record<string, string>>
  dipnot: string
}

export const ayarlar = {
  tesis: () => api<TesisAyarlari>('/api/ayarlar/tesis'),

  tesisYaz: (govde: TesisAyarlariIstek) =>
    api<TesisAyarlari>('/api/ayarlar/tesis', { yontem: 'PUT', govde }),

  esikler: () => api<EsikSatiri[]>('/api/ayarlar/esikler'),

  esikleriYaz: (govde: EsikYaz[]) =>
    api<EsikSatiri[]>('/api/ayarlar/esikler', { yontem: 'PUT', govde }),

  rolMatrisi: () => api<RolMatrisi>('/api/ayarlar/rol-matrisi'),
}

export const kullanicilar = {
  liste: () => api<KullaniciSatiri[]>('/api/kullanicilar'),

  davet: (govde: KullaniciDavet) =>
    api<{ id: string; eposta: string; not: string }>('/api/kullanicilar', {
      yontem: 'POST',
      govde,
    }),

  guncelle: (id: string, govde: KullaniciGuncelle) =>
    api<KullaniciSatiri[]>(`/api/kullanicilar/${id}`, { yontem: 'PUT', govde }),
}
